<nav class="vertical-stepper">
  <ol>
    @for (s of steps(); track s.id; let i = $index) {
      <li (click)="showStep(s)" [class]="getStepOuterRingClass(s)">
        <span class="step-icon">
          <span>{{i+1}}</span>
        </span>
        <div class="step-label-container">
          <div></div>
          <span class="step-label">{{s.name}}</span>
          @if (hasError(s)) {
            <span class="step-description-error">{{s.errorText}}</span>
          }
          @else if (hasWarning(s)) {
          <span class="step-description-warning">{{s.warningText}}</span>
        }
        @else {
        <span class="step-description-info">{{s.infoText}}</span>
      }
    </div>
  </li>
}
</ol>
</nav>